const pad2 = (n: number): string => (n < 10 ? `0${n}` : String(n));

const toDate = (value: string | Date | null | undefined): Date | null => {
  if (value === null || value === undefined || value === '') return null;
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d;
};

/** Render a date as DD.MM.YYYY (empty/invalid → "—"). */
export const formatDate = (value: string | Date | null | undefined): string => {
  const d = toDate(value);
  if (!d) return '—';
  return `${pad2(d.getDate())}.${pad2(d.getMonth() + 1)}.${d.getFullYear()}`;
};

/** Render a datetime as DD.MM.YYYY HH:mm (empty/invalid → "—"). */
export const formatDateTime = (value: string | Date | null | undefined): string => {
  const d = toDate(value);
  if (!d) return '—';
  return `${pad2(d.getDate())}.${pad2(d.getMonth() + 1)}.${d.getFullYear()} ${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
};
